<template>
    <div>

        <div :style="{height:height+'px'}" class="ly-video-containner font-nomal" ref="root" @click="videoboxclick()">
            <video
                    autoplay
                    x5-video-player-fullscreen='true'
                    x-webkit-airplay='true'
                    webkit-playsinline='true'
                    playsinline='true'
                    x5-playsinline

                    :src="src"
                    :poster="poster"
                    ref="video"

            ></video>


            <div class="ly-video-control" v-if="showcontrol">
                <div class="ly-video-control-head"></div>
                <div class="ly-video-control-content">

                    <div class="ly-video-error" v-if="error">
                        <div>视频出错</div>
                        <div class="ly-video-error-reload" @click="reload()">刷新</div>
                    </div>
                    <!--                        <van-loading size="50" v-else-if="loadding" />-->
                    <div class="ly-loading2" v-else-if="loadding">
                        <img :src="require('../assets/loading.svg')">
                    </div>
                    <div class="ly-video-btn" v-else-if="playing" @click="pause()">
                        <img :src="require('../assets/stop.svg')">
                    </div>
                    <div class="ly-video-btn ly-video-btn-play" v-else-if="!playing" @click="play()">
                        <img :src="require('../assets/play.svg')">
                    </div>

                </div>
                <div class="ly-video-control-bottom">

                    <div>{{currentTime_slider_time}}/{{duration_slider_time}}</div>
                    <div class="ly-video-control-slider">
<!--                        <van-slider active-color="red"-->
<!--                                    button-size="20"-->
<!--                                    v-model="current_slider" :min="0" :max="100" @drag-end="slider_change"-->
<!--                                    @drag-start="drag_start"/>-->
                    </div>

                    <div class="ly-video-control-full" @click="fullscreen()" v-if="showfullscreen">
                        <img :src="require('../assets/full.svg')">
                    </div>
                </div>
            </div>

            <div class="ly-video-line-slider-containner" v-else>
                <!--                    <div class="ly-loading" v-if="error || loadding">-->
                <div class="ly-loading2" v-if="error || loadding">
                    <img :src="require('../assets/loading.svg')">
                </div>
                <div class="ly-video-error" v-if="error">
                    <div>视频出错</div>
                    <div class="ly-video-error-reload" @click="reload()">刷新</div>
                </div>
                <van-loading size="50" v-else-if="loadding"/>
            </div>
            <div class="ly-video-line-slider">
                <div data-name="缓存" :style="{width:buffered_slider===0?0:buffered_slider+'%'}"></div>
                <p data-name="播放进度" :style="{width:current_slider===0?0:current_slider+'%'}"></p>
            </div>
        </div>


    </div>

</template>

<script>
    export default {
        name: 'layVideo',
        props: {
            src: String,
            height: Number,
            poster: String,
            autoplay: Boolean,
            currentpath: String,
            playEndFun: Function,
            pmuted: Boolean,
            showfullscreen:Boolean
        },
        data: function () {
            return {
                getTimeInterval: false,
                percent: 0,//百分比
                duration: 0,//视频总时长
                currentTime: 0,//当前播放进度
                error: false,
                duration_slider_time: "0:00",
                currentTime_slider_time: "0:00",
                current_slider: 0,//当前播放进度
                buffered_slider: 0,//缓冲进度
                showcontrol: false,//现在控制器
                playing: false,//视频是否在播放
                loadding: true,//显示加载loading
                isfullscreen: false,//当前是否全屏状态
                isfirsttime: true,
                hidecontroltimer: false,
                muted: this.pmuted

            }
        },
        created: function () {

            if (!this.height) {
                this.height = 300
            }
            this.muted = this.pmuted;


        },
        watch: {
            pmuted(muted) {
                this.muted = muted;
                this.$forceUpdate();
                try {
                    this.$refs.video.muted = muted;
                } catch (e) {
                }
            },
            src(src){
                this.$refs.video.src = src
            }
        },
        mounted: function () {

            var video = this.$refs.video;
            if (!video) {
                let timer = setInterval(() => {
                    if (video) {
                        clearInterval(timer);

                        this.addeventLister();
                        this.$refs.video.load()

                    }
                }, 500)
            } else {

                this.addeventLister();
                this.$refs.video.load()
            }

        },
        beforeDestroy: function () {

            if (this.getTimeInterval) {
                clearInterval(this.getTimeInterval)
            }
        },
        methods: {
            setVoice(muted) {
                try {
                    this.$refs.video.muted = muted;
                    this.muted = muted;
                } catch (e) {

                }
            },
            gettime() {
                if (this.getTimeInterval) {
                    clearInterval(this.getTimeInterval)
                }
                this.getTimeInterval = setInterval(() => {
                    if (this.$refs.video) {
                        try {
                            let currentTime = this.$refs.video.currentTime;
                            if (currentTime && currentTime > 0) {
                                this.currentTime = currentTime;
                                this.updateTime();
                                if (this.$refs.video.paused) {
                                    this.playing = false;
                                    this.error = false;
                                }
                                if (this.$refs.video.error) {
                                    this.playing = false;
                                    this.error = true;
                                }

                            }
                        } catch (e) {
                        }
                    }
                }, 1000)
            },
            pause() {
                try {
                    this.$refs.video.pause()
                } catch (e) {

                }
            },
            play() {
                try {
                    this.$refs.video.play();
                    if (this.muted) {
                        this.$refs.video.muted = true;
                    }
                } catch (e) {

                }
            },
            videoboxclick() {
                if (!this.showcontrol) {
                    this.showcontrol = true;
                    if (this.hidecontroltimer) {
                        clearTimeout(this.hidecontroltimer)
                        this.hidecontroltimer = false
                    }
                    this.hidecontroltimer = setTimeout(() => {
                        this.showcontrol = false;

                    }, 2000)
                }
            },
            getVideoTime(time) {
                var hour = parseInt(time / 3600);
                var minute = parseInt((time % 3600) / 60);
                var second = Math.ceil(time % 60);
                var str = [];
                if (hour) {
                    str.push(hour)
                }
                if (minute || minute === 0) {
                    if (minute < 10) {
                        str.push('0' + minute)
                    } else {
                        str.push(minute)
                    }
                }
                if (second || minute === 0) {
                    if (second < 10) {
                        str.push('0' + second)
                    } else {
                        str.push(second)
                    }
                }
                return str.join(':')
            },

            playend() {
                try {
                    this.$emit('playEndFun')
                } catch (e) {

                }
            },
            addeventLister() {
                this.gettime()
                //视频缓冲完成可以播放
                this.$refs.video.oncanplay = () => {
                    if (!this.$refs.video) {
                        return
                    }
                    if (this.muted) {
                        this.$refs.video.muted = true;
                    }
                    this.loadding = false;
                    this.error = false;

                    if (this.isfirsttime) {
                        this.isfirsttime = false;
                        try {

                            this.$refs.video.play()
                        } catch (e) {

                        }
                    }

                    this.muted = this.$refs.muted

                }
                //视频时间改变
                this.$refs.video.ondurationchange = (event) => {
                    //console.log('视频时间改变',event);
                    try {
                        this.error = false;
                        this.duration = this.$refs.video.duration;
                        this.currentTime = this.$refs.video.currentTime;
                        this.updateTime();
                        if (this.muted) {
                            this.$refs.video.muted = true;
                        }
                    } catch (e) {

                    }
                };
                //缺少数据缓存等待中
                this.$refs.video.onwaiting = (event) => {
                    this.loadding = true;
                    this.error = false;
                    //console.log('缺少数据缓存等待中',event);
                };
                //视频播放中
                this.$refs.video.onplaying = (event) => {
                    this.loadding = false;
                    this.playing = true;
                    this.error = false;
                    //console.log('视频播放中',event);
                    if (this.muted) {
                        this.$refs.video.muted = true;
                    }
                };
                //视频暂停
                this.$refs.video.onpause = (event) => {
                    //console.log('视频暂停',event);
                    this.playing = false;
                    this.error = false;
                };
                //当媒介资源元素突然为空时（网络错误、加载错误等）运行脚本
                this.$refs.video.onemptied = () => {
                    if (this.playing) {
                        this.error = true;
                        this.playing = false
                    }

                };
                //播放进度刷新
                // this.$refs.video.ontimeupdate = (event) => {
                //     // console.log(event);
                //     this.currentTime = this.$refs.video.currentTime;
                //     this.updateTime();
                // };

                //播放视频
                this.$refs.video.onplay = (event) => {
                    //console.log('播放视频');
                    this.playing = true;
                    this.error = false;
                    if (this.muted) {
                        this.$refs.video.muted = true;
                    }
                };
                // //加载出错
                this.$refs.video.onerror = (event) => {
                    this.error = true;
                    this.playend();

                    //console.log('加载暂停',event);
                };
                //播放结束
                this.$refs.video.onended = (event) => {
                    this.playing = false;
                    this.loadding = false;
                    this.error = false;
                    this.showcontrol = true;
                    this.playend();
                    //console.log('加载暂停',event);
                };
                // this.$refs.video.onseeking = (event) => {
                //     alert('onseeking')
                //     //console.log('加载暂停',event);
                // };
                // this.$refs.video.onseeked = (event) => {
                //     alert('onseeked')
                //     //console.log('加载暂停',event);
                // };


                //onloadedmetadata
                this.$refs.video.onloadedmetadata = (event) => {
                    // console.log('onloadedmetadata',event);
                    // console.log(video.duration)

                    try {
                        this.duration = this.$refs.video.duration;
                        this.currentTime = this.$refs.video.currentTime;
                        this.updateTime();
                        this.error = false;
                        if (this.muted) {
                            this.$refs.video.muted = true;
                        }
                    } catch (e) {
                    }
                };
            },
            updateTime() {
                this.duration_slider_time = this.getVideoTime(this.duration);
                this.currentTime_slider_time = this.getVideoTime(this.currentTime);
                this.current_slider = (this.currentTime / this.duration * 100).toFixed(2);


                try {
                    var buffered = this.$refs.video.buffered;
                    var bufferedlength = buffered.end(0);
                    this.buffered_slider = (bufferedlength / this.duration * 100).toFixed(2);

                } catch (e) {
                    console.log(JSON.stringify(e))
                }


            },
            setfull(elem, notsetisfullscreen) {
                if (elem.requestFullscreen) {
                    elem.requestFullscreen();
                    if (!notsetisfullscreen) {
                        this.isfullscreen = true;
                    }

                } else if (elem.msRequestFullscreen) {
                    elem.msRequestFullscreen();
                    if (!notsetisfullscreen) {
                        this.isfullscreen = true;
                    }
                } else if (elem.mozRequestFullScreen) {
                    elem.mozRequestFullScreen();
                    if (!notsetisfullscreen) {
                        this.isfullscreen = true;
                    }
                } else if (elem.webkitRequestFullscreen) {
                    elem.webkitRequestFullscreen();
                    if (!notsetisfullscreen) {
                        this.isfullscreen = true;
                    }
                } else if (elem.webkitEnterFullscreen) {

                    elem.webkitEnterFullscreen();
                    if (!notsetisfullscreen) {
                        this.isfullscreen = true;
                    }
                } else {
                    return "不能全屏"
                }
            },
            fullscreen() {
                if (this.isfullscreen) {
                    if (document.cancelFullScreen) {
                        document.cancelFullScreen();
                    } else if (document.webkitCancelFullScreen) {
                        document.webkitCancelFullScreen();
                    } else if (document.mozCancelFullScreen) {
                        document.mozCancelFullScreen();
                    } else if (document.msCancelFullScreen) {
                        document.msCancelFullScreen();
                    } else {
                        document.exitFullscreen();
                    }

                    this.isfullscreen = false;

                    return
                }


                let err = this.setfull(this.$refs.root);
                if (err) {
                    err = this.setfull(this.$refs.video, true);
                    this.$refs.video.addEventListener('webkitendfullscreen', (e) => {


                        setTimeout(() => {
                            this.play()
                        }, 500)
                        // });
                    });
                } else {
                }


            },
            slider_change() {
                let current = this.duration * this.current_slider / 100;
                this.$refs.video.currentTime = current;
                this.hidecontroltimer = setTimeout(() => {
                    this.showcontrol = false;

                }, 2000)

            },
            drag_start() {
                if (this.hidecontroltimer) {
                    clearTimeout(this.hidecontroltimer);
                    this.hidecontroltimer = false
                }

            },
            reload() {
                this.$refs.video.load()
            }


        },
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

  .ly-video-containner{ width: 100%; background-color: #000; position: relative; transform: translate3d(0,0,0); overflow:hidden}
  .ly-video-containner video{ display: block;background-color: #000; width: 100%; height: 100%}
  .ly-video-line-slider{width: 100%; position: absolute; left: 0; bottom:0; height: 2px; background-color: rgba(255,255,255,0.4)}
  .ly-video-line-slider div{position: absolute; left: 0; bottom:0; height: 2px; background-color: rgba(255,255,255,0.6)}
  .ly-video-line-slider p{padding: 0; margin: 0;position: absolute; left: 0; bottom:0; height: 2px; background-color: red}
  .ly-loading{ display: flex; justify-content: center; align-items: center;position: absolute;
    left: 0; top:0; bottom:0; width: 100%}

  .ly-video-control{ position: absolute;display: flex; left: 0; top:0; bottom:0; width: 100%;
    flex-direction: column;z-index: 50;
  }
  .ly-video-control-head{ width: 100%; height: 40px; display: flex; align-items: center; justify-content: space-between}
  .ly-video-control-content{ display: flex; flex: 1; justify-content: center;
    align-items: center}
  .ly-video-control-bottom{width: 100%; height: 40px; display: flex;align-items: center;
    /*background-image: -webkit-linear-gradient( 90deg, rgba(0,0,0,0.5) 0%, rgba(0,0,0,0.2) 60%, rgba(0,0,0,0) 100%);*/
    /*background-image: url(../image/top0_top_bottom.png);*/
    background-repeat: repeat-x;background-size: auto 100%;
    box-sizing: border-box; padding: 0 12px; color: #fff; font-size: 12px;justify-content: space-between}
  .ly-video-control-full img{ height: 18px}
  .ly-video-control-full{ margin-left: 10px; cursor: pointer}
  .ly-video-control-slider{ display: flex; flex: 1; padding: 0 15px; box-sizing: border-box;}
  .ly-video-btn{ width: 60px; height: 60px; display: flex; justify-content: center;
    align-items: center; background-color: rgba(0,0,0,0.5); border-radius: 50%}
  .ly-video-btn img{ height: 30px}
  .ly-video-btn-play img{padding-left: 5px }
  .ly-video-error{ border-radius: 6px; background-color: rgba(0,0,0,0.5);
    display: flex; justify-content: center; align-items: center; padding: 15px;
    width: 130px;font-size: 16px; color: #fff; text-align: center;flex-direction: column;
  }
  .ly-video-error-reload{ width:50px; height: 24px; line-height: 24px; border-radius: 6px;
    margin: auto; margin-top: 6px; border: 1px solid #fff; font-size: 14px;
  }

  .ly-video-control-voice{ height: 40px; width: 40px}
  .ly-video-control-voice div{ height: 40px; width: 40px;display: flex; justify-content: center; align-items: center; font-size: 0}
  .ly-video-control-voice svg{ width: 18px; height: 18px;}

  .default-video-item-bottom-i div{height: 40px; width: 20px;display: flex; justify-content: center; align-items: center; font-size: 0}
  .default-video-item-bottom-i svg{ width: 18px; height: 18px; margin-right: 4px}
</style>
